import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, TextField } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { signupApiCall } from "../../utils/Apicalls";
import SpinnerShow from "../../components/Spinner";
import Header from "../../components/common/header/Header";
import Footer from "../../components/common/footer/Footer";
import "./signup.css";

function SignupPage() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [userName, setUserName] = useState("");
  const [mobile, setMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [msgType, setMsgType] = useState("");
  const [error, setError] = useState("");

  // Check if user is already logged in, redirect to interview page if they are
  useEffect(() => {
    const userDetails = localStorage.getItem("userDetails");
    if (userDetails) {
      // User is already logged in, redirect to interview page
      navigate("/home");
    }
  }, [navigate]);

  const validateForm = () => {
    if (!firstName.trim()) {
      setError("Please enter your name");
      return false;
    }
    if (!userName.trim()) {
      setError("Please enter your email");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(userName)) {
      setError("Please enter a valid email address");
      return false;
    }
    // mobile is optional, no validation
    return true;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    setLoading(true);
    setError("");
    try {
      const result = await signupApiCall({
        firstName: firstName,
        email: userName,
        mobile: mobile
      });
      setLoading(false);
      if (result?.status) {
        setMsgType("redirectLogin");
      } else {
        setError(result?.message || "Failed to create account. Please try again.");
      }
    } catch (err) {
      setLoading(false);
      setError("An error occurred while creating your account. Please try again later.");
      console.error("Signup error:", err);
    }
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <>
      <Header />
      <div className="modern-login-container">
        <div className="modern-login-card">
          {loading && (
            <div className="spinner-container">
              <SpinnerShow />
            </div>
          )}
          
          {error && !loading && (
            <div className="login-error-alert">
              <Alert severity="error">{error}</Alert>
            </div>
          )}
          
          {!loading && !msgType && (
            <>
              <h2 className="modern-login-title">Create Your Account</h2>
              
              <form className="modern-login-form" onSubmit={onSubmit}>
                <div className="modern-input-field">
                  <TextField
                    id="name-input"
                    label="Full Name"
                    variant="outlined"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    placeholder="Enter your full name"
                    fullWidth
                    required
                  />
                </div>
                
                <div className="modern-input-field">
                  <TextField
                    id="email-input"
                    label="Email"
                    variant="outlined"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    placeholder="Enter your email"
                    fullWidth
                    type="email"
                    required
                  />
                </div>
                
                <div className="modern-input-field">
                  <TextField
                    id="mobile-input"
                    label="Mobile (optional)"
                    variant="outlined"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    placeholder="Enter your mobile number"
                    fullWidth
                    type="tel"
                  />
                </div>
                
                <button className="modern-login-button" type="submit">
                  CREATE ACCOUNT
                  <ArrowForward className="arrow-icon" />
                </button>
              </form>
              
              <div className="modern-links-container">
                <div className="account-question-container">
                  <p className="account-question">Already have an account?</p>
                  <button className="signup-button" onClick={handleLoginClick}>
                    Log in
                  </button>
                </div>
              </div>
            </>
          )}
          
          {!loading && msgType === "redirectLogin" && (
            <div className="success-message-container">
              <h3 className="success-title">Account Created Successfully!</h3>
              <p className="success-text">
                A temporary password has been sent to your email address.
                Please check your inbox and use it to log in.
              </p>
              <button className="modern-login-button" onClick={() => navigate("/login")}>
                GO TO LOGIN
                <ArrowForward className="arrow-icon" />
              </button>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SignupPage;




